export default __webpack_public_path__ + "static/human-rights-0586a0ce67e931ba93040bb780729eb0.png";